import { Table } from "antd";
import { useEffect, useState } from "react";
import DeleteBoooking from "./components/DeleteBoooking";
import CreateBooking from "./components/CreateBooking";
import ConfirmDrive from "./components/ConfirmDrive";
import Moment from "react-moment";
import { BsCheckSquare } from "react-icons/bs";
import Toastify from "toastify-js";
import fetchData from "../../../services/fetchData";
import PageHeader from "../../../components/shared/PageHeader";
import { pusher } from "../../..";

export default function NewDrives() {
  const [createModal, setCreateModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [bookings, setBookings] = useState([]);

  const handleFetchDrives = async () => {
    const data = await fetchData({ uri: "drives" });
    setBookings(data?.payload);
  };

  useEffect(() => {
    handleFetchDrives();
    const book = pusher.subscribe(`booking`);
    book.bind("sent", function (data: any) {
      handleFetchDrives();

      Toastify({
        text: `New Test drive Requested`,
        duration: 3000,
        close: true,
        gravity: "top",
        position: "right",
        style: {
          marginTop: "80px",
          background: "#16A34A",
          fontWeight: "bold",
        },
        stopOnFocus: true,
        onClick: function () {},
      }).showToast();
    });

    return () => {
      pusher.unsubscribe("drives");
    };
  }, []);

  const columns = [
    {
      title: "S/N",
      width: 50,
      dataIndex: "",
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Customer",
      width: 150,
      dataIndex: "",
      render: (record: any) => (
        <div className="w-full">
          {record?.customer_code === 0 ? (
            <div className="text-gray-700 bg-red-200 p-2 w-full">
              <span className="mr-2"> Guest:</span>

              {record?.customer_name === null ? "-" : record?.customer_name}
            </div>
          ) : (
            <div className="p-2">
              {record?.customer_name === null ? "-" : record?.customer_name}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Requested",
      width: 140,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.createdAt === null ? (
            "-"
          ) : (
            <Moment fromNow>{record?.createdAt}</Moment>
          )}
        </span>
      ),
    },
    {
      title: "Model",
      width: 80,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.model === null ? "-" : record?.model?.name}
        </span>
      ),
    },

    {
      title: "Date",
      width: 120,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.date === null ? (
            "-"
          ) : (
            <>
              <Moment format="Do MMM, YYYY">{record?.date}</Moment>
            </>
          )}
        </span>
      ),
    },

    {
      title: "Time",
      width: 150,
      dataIndex: "",
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.slottime === null ? (
            "-"
          ) : (
            <>
              <Moment format="HH:mm A">{record?.drivetime?.starttime}</Moment>
              <span className="mx-2">-</span>
              <Moment format="HH:mm A">{record?.drivetime?.endtime}</Moment>
            </>
          )}
        </span>
      ),
    },

    {
      title: "Assigned To",
      width: 120,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex items-center text-gray-700">
          <span className="ml-1">
            {record?.assignedTo
              ? `${record?.assignedTo?.firstname}  ${record?.assignedTo?.lastname}`
              : "-"}
          </span>
        </div>
      ),
    },

    {
      title: "Status",
      width: 100,
      dataIndex: "",
      render: (record: any) => (
        <div className="flex">
          {record.is_confirmed ? (
            <button className="flex justify-center items-center ml-1 text-green-700 border rounded-md p-2 bg-green-100 hover:bg-green-200 cursor-not-allowed">
              <BsCheckSquare /> <span className="ml-1">Confirmed</span>
            </button>
          ) : (
            <button
              onClick={() => {
                setSelected({
                  ...record,
                });
                setConfirmModal(true);
              }}
              className="flex justify-center items-center text-red-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
            >
              <span className="ml-1">Unconfirmed </span>
            </button>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col border border-gray-300 mx-4 rounded-lg mt-2 bg-white">
      <div className="">
        <PageHeader
          title="Test Drive"
          subtitle="List of recent requests"
          hasLogo={true}
          tag="List"
          actions={<></>}
        />

        <div className="grid gap-x-0 grid-cols-12">
          <div className="col-span-12 sm:col-span-12 md:col-span-12">
            <Table
              columns={columns}
              dataSource={bookings}
              size="small"
              pagination={{ pageSize: 20 }}
              scroll={{ y: 425 }}
              rowKey="id"
            />

            <CreateBooking
              isVisible={createModal}
              setCreateModal={setCreateModal}
            />

            <ConfirmDrive
              selected={selected}
              isVisible={confirmModal}
              setConfirmModal={setConfirmModal}
              handleFetchDrives={handleFetchDrives}
            />

            <DeleteBoooking
              selected={selected}
              isVisible={deleteModal}
              setDeleteModal={setDeleteModal}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
